import { combineReducers } from 'redux';

import data from './data';
import links from './links';
import ui from './ui';

export default combineReducers({ data, ui, links });
